import React from 'react';
import {
  BRANCH_PARENT_DELETION_MODAL,
  CONFIRM_PAYMENT_MODAL,
  CREATE_ORGANIZATION_MODAL,
  LOGOUT_CONFIRMATION_MODAL,
} from '../globalModals';
import {CreateOrganization} from '../../CreateOrganization';
import ConfirmationModal from '../../../uiToolkit/ConfirmationModal';
import {appText} from '../../../assets/text/appText';
import {BRANCH_VIDEO_PARENT_CONFIRMATION_ALIAS} from '../../../uiToolkit/ConfirmationModal/modalAliases';
import ConfirmPaymentModal from '../../../uiToolkit/ConfirmPaymentModal/ConfirmPaymentModal';

interface Props {
  activeModal?: string;
  openingPayload?: any;
  onClose: (payload?: any) => void;
}

const ModalProviderUI = React.memo(
  ({activeModal, openingPayload, onClose}: Props) => {
    if (activeModal === CREATE_ORGANIZATION_MODAL) {
      return <CreateOrganization isOpen={true} onClose={onClose} />;
    }
    if (activeModal === LOGOUT_CONFIRMATION_MODAL) {
      return (
        <ConfirmationModal
          title={appText.logoutConfirm}
          onCancel={onClose}
          acceptText={appText.logout}
          onAccept={() => onClose(true)}
          shown
        />
      );
    }
    if (activeModal === BRANCH_PARENT_DELETION_MODAL) {
      return (
        <ConfirmationModal
          title={
            <>
              <p>{appText.replaceSourceTitle}</p>
              <p>{appText.replaceSourceConfirmation}</p>
            </>
          }
          onCancel={onClose}
          acceptText={appText.continue}
          onAccept={() => onClose(true)}
          shown
          cacheAliasForDontShow={BRANCH_VIDEO_PARENT_CONFIRMATION_ALIAS}
        />
      );
    }
    if (activeModal === CONFIRM_PAYMENT_MODAL) {
      return (
        <ConfirmPaymentModal
          openingPayload={openingPayload}
          onCancel={() => onClose(false)}
          onAccept={() => onClose(true)}
        />
      );
    }
    return null;
  },
);

export default ModalProviderUI;
